module.exports = __webpack_public_path__ + "img/san-jose-room-2.ac956ddf.jpg";